import { type Currency, crmServiceAPI } from '@backmarket/http-api'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useAuthStore } from '@backmarket/nuxt-module-oauth/useAuthStore'
import { useUserStore } from '@backmarket/nuxt-module-oauth/useUserStore'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

export async function updateUserContext() {
  const { userId } = useAuthStore()

  if (!userId) {
    return
  }

  try {
    const userStore = useUserStore()
    const { user } = userStore

    const crmData = user.clientId
      ? await $httpFetch(crmServiceAPI.getCustomerId)
      : undefined
    const crmId = crmData ? crmData.crmId : ''

    const tracking = useTracking()

    tracking.setUserContext({
      userId,
      isStaff: user.isStaff,
      clientId: user.clientId,
      emailHashed: user.emailHashed || '',
      merchantId: user.merchantId,
      lastOrderDate: String(user.lastOrderDate),
      numberOfOrders: user.numberOfOrders,
      lifetimeRevenue: {
        currency: <Currency>user.lifetimeRevenue.currency || '',
        amount: String(user.lifetimeRevenue.amount),
      },
      crmId,
    })
  } catch (err) {
    const logger = useLogger()

    const error = err as Error
    logger.error(error.message, { error })
  }
}
